import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { modalDataSelector } from '../shared/modals/modals.selectors';

import SubmitRequestModalNames from './support/submitRequest/modalNames';
import SubmitRequestModal from './support/submitRequest/submitRequestModal.component';

class GlobalModalContainer extends PureComponent {
  static propTypes = {
    submitRequestModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
    }),
  };
  render() {
    const {
      submitRequestModalData,
    } = this.props;

    return (
      <div>
        <SubmitRequestModal isVisible={submitRequestModalData.show} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    submitRequestModalData: modalDataSelector(state, SubmitRequestModalNames.SubmitRequest),
  };
}

export default connect(mapStateToProps)(GlobalModalContainer);
